import { useQuery } from "@tanstack/react-query";
import { client } from "@johnpaul/jp-api-client";

export const useCrossSellConcierges = (
  family: string,
  subfamily: string | undefined,
  lang: string,
  enabled = true,
) => {
  return useQuery({
    queryKey: ["crossSell", lang],
    queryFn: () =>
      client.requests.crossSell.fetch({
        family,
        subfamily,
        lang,
      }),
    enabled,
    retry: false,
    gcTime: 0,
  });
};
